import { useState, useEffect } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '施工体制台帳の作成にはどのくらいの時間がかかりますか?',
      answer: '通常、必要書類をご提供いただいてから2〜3営業日で作成いたします。お急ぎの場合は最短即日対応も可能です。まずはお気軽にご相談ください。'
    },
    {
      question: 'グリーンサイトへの登録もサポートしてもらえますか?',
      answer: 'はい、グリーンサイトへの登録から書類のアップロードまで、すべてサポートいたします。電子化に不慣れな方でも安心してご利用いただけます。'
    },
    {
      question: '料金はどのように決まりますか?',
      answer: '作成する書類の種類や数量、工事の規模によって料金が変わります。まずは無料でお見積りをさせていただきますので、お気軽にお問い合わせください。'
    },
    {
      question: '遠方からでも依頼できますか?',
      answer: 'はい、全国どこからでもご依頼いただけます。メールやオンラインでのやり取りで完結しますので、遠方の方でも問題なくご利用いただけます。'
    },
    {
      question: '月額サポートプランの内容を教えてください',
      answer: '月額サポートプランでは、毎月の書類作成を定額でサポートいたします。複数の現場を抱える企業様に最適なプランで、コスト削減と業務効率化を実現できます。'
    },
    {
      question: '作成した書類の修正は可能ですか?',
      answer: 'はい、作成後の修正にも対応しております。内容に変更があった場合や、追加の書類が必要になった場合もお気軽にご相談ください。'
    }
  ];

  useEffect(() => {
    // Add FAQPage Schema.org JSON-LD
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <section id="faq" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <div className="inline-block px-4 sm:px-6 py-1.5 sm:py-2 bg-[#ff6b35]/10 rounded-full mb-4 sm:mb-6">
            <span className="text-xs sm:text-sm font-bold text-[#ff6b35]">よくある質問</span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1a2332] mb-4 sm:mb-6">
            FAQ
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 px-4">
            お客様からよくいただくご質問にお答えします
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden transition-all hover:shadow-md"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 sm:px-6 lg:px-8 py-4 sm:py-5 lg:py-6 flex items-center justify-between text-left cursor-pointer"
              >
                <h4 className="text-sm sm:text-base lg:text-lg font-bold text-[#1a2332] pr-4">
                  <a id={`faq-${index + 1}`} className="no-underline">
                    {faq.question}
                  </a>
                </h4>
                <div className={`w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-xl sm:text-2xl text-[#ff6b35]"></i>
                </div>
              </button>
              
              <div 
                className={`transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 sm:px-6 lg:px-8 pb-4 sm:pb-5 lg:pb-6 text-sm sm:text-base text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
